<nz-select [(ngModel)]="selectedOption"
           [nzPlaceHolder]="'select.placeholder' | translate"
           (ngModelChange)="onSelectModelChange()"
           [compareWith]="compareCheckBoxOption">
  <nz-option *ngFor="let option of _options"
             [nzValue]="option" [nzLabel]="option.id | translate"
  ></nz-option>
</nz-select>
